import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './content-list2.css'

const ContentList2 = (props) => {
  return (
    <div className="content-list2-container thq-section-padding">
      <div className="content-list2-max-width thq-section-max-width thq-flex-column">
        <div className="content-list2-content thq-flex-column">

              <h2>
                {props.heading1 ?? (
                  <Fragment>
                    <h2 className="content-list2-text7 thq-heading-2">
                      Empowering Commonwealth Nations Through AI
                    </h2>
                  </Fragment>
                )}
              </h2>

                  <h3>
                    {props.heading2 ?? (
                      <Fragment>
                        <span className="content-list2-text54 thq-body-large" style={{ fontWeight: 'normal', textAlign: 'justify' }}>
                          The Commonwealth Artificial Intelligence Consortium (CAIC) is committed to leveraging the power of AI for sustainable development across Commonwealth nations. The consortium focuses on supporting small states and vulnerable nations, helping them bridge the global digital divide through capacity building, policy development, and infrastructural support. Recognizing the vast potential of AI to contribute up to $15.7 trillion to the global economy by 2030, CAIC aims to ensure that even the most at-risk nations benefit from this digital revolution.
                        </span>
                      </Fragment>
                    )}
                  </h3>

                  <h3>
                    {props.heading3 ?? (
                      <Fragment>
                        <span className="content-list2-text55 thq-body-large" style={{ fontWeight: 'normal', textAlign: 'justify' }}>
                          CAIC operates through four key working groups: Policy Development, Capacity Building, Research & Innovation, and Data & Infrastructure. These groups work collaboratively with stakeholders such as governments, academia, and tech giants. Key activities include fostering national AI strategies, developing digital infrastructure, and empowering women and youth through inclusive AI initiatives. By building digital literacy, supporting innovation, and creating AI-driven job opportunities, CAIC endeavors to reduce the digital divide and ensure equitable participation in the global AI economy.
                        </span>
                      </Fragment>
                    )}
                  </h3>

                  <h3>
                    {props.heading4 ?? (
                      <Fragment>
                        <span className="content-list2-text56 thq-body-large" style={{ fontWeight: 'normal', textAlign: 'justify' }}>
                          Expected outcomes from these initiatives include a cadre of empowered AI professionals, national AI policies tailored to small states, and enhanced AI infrastructure to support local entrepreneurship. With a focus on improving digital literacy and providing access to cutting-edge technologies, CAIC is driving the inclusion of all Commonwealth nations in the AI-driven future.
                        </span>
                      </Fragment>
                    )}
                  </h3>

        </div>
      </div>
    </div>
  )
}

ContentList2.defaultProps = {
  heading4: undefined,
  heading3: undefined,
  heading2: undefined,
  heading1: undefined,
}

ContentList2.propTypes = {
  heading4: PropTypes.element,
  heading3: PropTypes.element,
  heading2: PropTypes.element,
  heading1: PropTypes.element,
}

export default ContentList2
